<template>
  <div class="zhiliuping">
    <div class="title">创建直流屏</div>
    <div class="box">
      <div class="item" v-for="(item, index) in list" :key="index">
        <operationzlp
          :title="item.roomName"
          :data="item"
          @addItem="addEquipmentToDirect"
          @upItem="updateEquipmentToCabinet"
          @deleteItem="delEquipmentToCabinet"
        ></operationzlp>
      </div>
    </div>
  </div>
</template>

<script>

import {
  Message
} from 'element-ui';
import operationzlp from "../shebei/setUpzhiliuping";
export default {
  components: { operationzlp },
  data() {
    return {
      id: "",
      list: [],
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.searchRoomEquipmentByDirect();
    // this.addEquipmentToDirect();
  },

  methods: {
    searchRoomEquipmentByDirect() {
      this.$http
        .post(
          "bma-distribution-service/equipment/searchRoomEquipmentByDirect",
          {
            equipmentTypeId: 5,
            projectId: this.id,
          }
        )
        .then((res) => {
          console.log("获取直流屏", res);
          if (res.code == 200) {
            this.list = res.data;
          }
        });
    },
    // 增加直流屏
    addEquipmentToDirect(id, input, equipmentCode) {
      this.$http
        .post("bma-distribution-service/equipment/addEquipmentToDirect", {
          equipmentTypeId: 5,
          roomId: id,
          equipmentCode: this.id + "_" + equipmentCode,
          localeNumber: input,
        })
        .then((res) => {
          console.log("增加直流屏", res);
          if (res.code == 200) {
            Message("增加成功");
            this.searchRoomEquipmentByDirect();
          }
        });
    },
    // 修改配电柜名称（编号）
    updateEquipmentToCabinet(id, input, equipmentCode) {
      this.$http
        .post("bma-distribution-service/equipment/updateEquipmentToCabinet", {
          localeNumber: input,
          equipmentId: id,
          equipmentCode: equipmentCode,
        })
        .then((res) => {
          console.log("修改", res);
          if (res.code == 200) {
            Message("修改成功");
            this.searchRoomEquipmentByDirect();
          }
        });
    },
    // 删除
    delEquipmentToCabinet(id) {
      this.$http
        .post("bma-distribution-service/equipment/delEquipmentToCabinet", {
          equipmentId: id,
        })
        .then((res) => {
          if (res.code == 200) {
            Message("删除成功");
            this.searchRoomEquipmentByDirect();
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.zhiliuping {
  width: 1625px;
  height: 836px;
  background: rgba(248, 248, 249, 1);
  padding: 20px;
  box-sizing: border-box;
  .title {
    font-size: 14px;
    font-weight: 600;
    color: #152139;
    letter-spacing: 3px;
    text-align: left;
  }
  .box {
    width: 100%;
    height: 690px;
    margin-top: 20px;
    overflow-x: scroll;
    display: flex;
    .item {
      margin-right: 20px;
      flex-shrink: 0;
      width: 320px;
      border: 1px solid #e7e7e7;
    }
  }
}
</style>